module.exports = require("tty");


//////////////////
// WEBPACK FOOTER
// external "tty"
// module id = 78
// module chunks = 0